import { useMemo, CSSProperties } from 'react';

import { Tag } from '../../../components/index';
import { chargeStatusList } from '../../../utils/lists';

const unbilledStatus = {
  id: 'UNBILLED',
  name: 'Não faturada',
  className: 'unbilled',
};

export function ChargeStatusTag(props: {
  status: string;
  style?: CSSProperties;
}) {
  const { status, style } = props;

  const selectedStatus = useMemo(() => {
    return (
      chargeStatusList.find((item) => item.id === status) || unbilledStatus
    );
  }, [status]);

  return (
    <Tag style={style} className={`charge-status ${selectedStatus?.className}`}>
      {selectedStatus.name}
    </Tag>
  );
}
